import React, { useState } from 'react';
import bemCn from 'bem-cn';
import { RouteFormatter } from '../../routes';
import { BLOG_CATEGORIES } from '../../consts/blog.consts';
import BlogArticleSimple from '../blog-article-simple';
import { FOLLOW_US } from '../footer-new';
import SniffButton from '../sniff-button';
import PictureSet from '../picture-set';
import SharePage from '../spot-share-button/share-page';
import SvgShare from 'src/assets/svg/SvgShare.svg';
import './style.scss';

const b = bemCn('sniff-blog-side-bar');

const TriggerComp = () => (
    <SniffButton className="mt-3" color="secondary" size="lg">
        <SvgShare className="me-2" />
        Share this page
    </SniffButton>
);

const BlogSideBar = ({ blogPost, useStateSSR }) => {
    const [shareModal, setShareModal] = useState(false);

    const toggleShareModal = () => setShareModal((s) => !s);

    return (
        <div className={b.mix('d-none d-md-block')}>
            <h5 className="snif-m2 snif-semibold mb-2">About Sniffspot</h5>
            <p className="snif-p mb-3">
                Sniffspot is a community marketplace that enables anyone to rent land by-the-hour as a safe and private dog park.
            </p>
            <a href={RouteFormatter.listings({})}>
                <SniffButton size="lg">Explore nearby spots</SniffButton>
            </a>
            <div className="b-bot my-5" />
            <h5 className="snif-m2 snif-semibold mb-2">Follow us</h5>
            <p className="snif-s2 text-deep mb-3">Find Sniffspot on your favorite social media</p>
            <div className="d-flex">
                {FOLLOW_US.map((v, i) => (
                    <a key={i} href={v.link} target="_blank" rel="noopener noreferrer">
                        <PictureSet className="me-2" imgs={v.img} alt={v.alt} width={48} height={48} useState={useStateSSR} SSR={!!useStateSSR} />
                    </a>
                ))}
            </div>
            <SharePage shareBlog {...{ title: 'Share this page!', TriggerComp, shareModal, toggleShareModal }} />
            {blogPost?.relatedPosts?.length > 0 && (
                <>
                    <div className="b-bot my-5" />
                    <h5 className="snif-m2 snif-semibold mb-2">Related articles</h5>
                    {blogPost?.relatedPosts?.map((v) => (
                        <BlogArticleSimple key={v.id} data={v} {...{ useStateSSR }} />
                    ))}
                </>
            )}
            <div className="b-bot my-5" />
            <h5 className="snif-m2 snif-semibold mb-1">All categories</h5>
            <ul style={{ paddingInlineStart: '28px' }}>
                {Object.keys(BLOG_CATEGORIES).map((v) => (
                    <li key={v} className={b('li-cat')}>
                        <a href={RouteFormatter.blogCategory({ id: BLOG_CATEGORIES[v].slug })} className="snif-p snif-medium text-dark">
                            {BLOG_CATEGORIES[v].name}
                        </a>
                    </li>
                ))}
                <li className={b('li-cat')}>
                    <a href={RouteFormatter.dogNames()} className="snif-p snif-medium text-dark">
                        Dog Names
                    </a>
                </li>
                <li className={b('li-cat')}>
                    <a href={RouteFormatter.dogRescue()} className="snif-p snif-medium text-dark">
                        Dog Rescues & Shelters
                    </a>
                </li>
            </ul>
        </div>
    );
};

export default BlogSideBar;
